function fixedNumber(num, n) {
  num = num.toString(16);
  let len = num.length;

  while (len < n) {
    num = "0" + num;
    len++;
  };

  return  num;
}

export const CxCyToRGBHex = (cx, cy) => {
    let left = 0,right = 1.0,mid = 0.5,d = 256;
    let r = 0,g = 0,b = 0;
    let sRGB = {r:0,g:0,b:0};
    let cieY;
    let index=0;

    while(d < 255 || d > 255.5){
      cieY = mid;
      sRGB = OppColorCvrtCIExyY2sRgb(cx,cy,cieY);
      // {r,g,b} = rgb;
      d = Math.max(sRGB.r,sRGB.g,sRGB.b);
      if ( d > 255 ){
          right = mid;
      }else{
          left = mid;
      }
      mid = (right-left)/2+left;
      //printf("%f,%f,%f,%f\r\n",left,right,mid,d);

      // console.log('CxCyToRGB 第',index,'次',d); 

      index = index +1;
    }

    r = sRGB.r < 0 ? 0 : sRGB.r;
    r = r > 255 ? 255 : r;

    g = sRGB.g < 0 ? 0 : sRGB.g;
    g = g > 255 ? 255 : g;
    b = sRGB.b < 0 ? 0 : sRGB.b;
    b = b > 255 ? 255 : b;
  
    return `#${fixedNumber(r,2)}${fixedNumber(g,2)}${fixedNumber(b,2)}`;


    // console.log('CxCyToRGBHex',cx,cy);
    // cx = cx > MaxX ? MaxX : cx;
    // cy = cy > MaxY ? MaxY : cy;
    // let x = cx / MaxX * xCount;
    // let y = (1 - cy / MaxY) * yCount;

    // x = x >= xCount ? (xCount - 1) : x;
    // y = y >= yCount ? (yCount - 1) : y;

    // let hex = '#c0c0c0';
    // try {
    //     hex = CxCyRGBDatas[Math.ceil(y)][Math.ceil(x)];
    // } catch (err) { 
    // }

    // if(hex == '#ffffff')
    // {
    //     console.log('CxCyToRGBHex 超出范围')
    //     hex = '#c0c0c0';
    // }

    // // hex = hex+'90';
 
    // return hex;
    // let Y = CIEYDatas[Math.ceil(y) ][Math.ceil(x)];
    // // console.log('矩形坐标：', Math.ceil(cy * 100), '***', cy, '***', Math.ceil(cx * 100), '**', cx, '*', Y);
    // return xyYToRGB(cx, cy, Y);
}
export const OppColorCvrtCIExyY2sRgb = (x,y,cieY) => {
    // console.log(' CxCyToRGB OppColorCvrtCIExyY2sRgb L ',x,y,cieY);
    // 计算RGB颜色值  
    let X,Y,Z,r,g,b;
    
    Y = cieY * 100;
    X = x * Y /y;
    Z = (1 -  x -  y) * Y /  y;

    X = X / 100;
    Y = Y / 100;
    Z = Z / 100;

    r = X *  3.1338561  + Y * -1.6168667  + Z * -0.4906146;
    g = X * -0.9787684  + Y *  1.9161415  + Z *  0.0334540;
    b = X *  0.0719453  + Y * -0.2289914  + Z *  1.4052427;

    if (r > 0.0031308) {
        r = 1.055 * Math.pow(r, (1/2.4)) - 0.055;
    }else{
        r = 12.92 * r;
    }
    if (g > 0.0031308) {
        g = 1.055 * Math.pow(g, (1/2.4)) - 0.055;
    }else{
        g = 12.92 * g;
    }
    if (b > 0.0031308) {
        b = 1.055 * Math.pow(b, (1/2.4)) - 0.055;
    }else{
        b = 12.92 * b;
    }
    r = Math.ceil( r * 255);
    g = Math.ceil(g * 255);
    b =Math.ceil( b * 255);

 
    // console.log(' CxCyToRGB OppColorCvrtCIExyY2sRgb rgb ',r,g,b);
   return {r,g,b};
}

export const CxCyValueToRGBHex = (value) => {
  const { cx, cy } = ValueToCxCy(value);

  return CxCyToRGBHex(cx, cy)
}

// export const CxCyValueToRGBA = (value) => {
//     const { cx, cy } = ValueToCxCy(value);
//     return CxCyToRGB(cx, cy)
// }


export const ValueToCxCy = (value) => {
  let cx = (value >> 16 & 0x0000ffff) / 10000;
  let cy = (value & 0x0000ffff) / 10000;

  return { cx, cy };
}
